<template>
  <div class="mail-content-attachments" v-if="attachments">
    <div class="attachments-top">
      <div class="attachments-top-icon">
        <img class="attach" src="@/assets/img/email/privitak.svg" />
        {{ attachments.length > 0 ? attachments.length : $t('components.email.attachments.no_attachments') }} {{
          $t('components.email.attachments.attachments') }}
      </div>
      <div class="attachments-top-amount" v-if="attachments.length > 0">
        {{ cumulateAttachmentSize() }} {{ $t('components.email.attachments.size_unit') }}
      </div>
    </div>
    <div class="attachments-content">


      <div class="attachment" v-for="attach in firstArray()" :key="attach.id">
        <div class="attachment-icon pdf">
          <img :src="getFileIcon(attach.name)" />
        </div>
        <div class="attachment-txt">
          <div class="doc-name">{{ getFileNameShorter(attach.name) }}</div>
          <div class="doc-size">
            {{ (attach.size * 0.000001).toFixed(4) }} {{ $t('components.email.attachments.size_unit_mb') }}
          </div>
        </div>


        <div>
          <div class="download-hover dh2" @click="downloadAttachment(attach)">
            <div class="download-button db2">
              <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.01 16.79">
                <defs></defs>
                <g id="Layer_1-2">
                  <path class="cls-1"
                    d="M17.17,8.97c-.25-.01-.45.07-.6.22-.17.17-.26.42-.26.75v2.62c0,1.48-1.03,2.52-2.49,2.52-3.21,0-6.41,0-9.62,0-1.47,0-2.49-1.04-2.49-2.51v-1.04c0-.55,0-1.1,0-1.65,0-.28-.09-.52-.25-.68-.15-.15-.36-.23-.6-.23h0c-.5,0-.84.37-.84.92,0,.32,0,.65,0,.97,0,.54,0,1.08,0,1.61-.03,1.19.4,2.29,1.22,3.11.78.77,1.84,1.21,2.93,1.21.05,0,.09,0,.14,0,1.08-.04,2.18-.03,3.25-.02.49,0,.98,0,1.47,0h.23s1.32,0,1.32,0c1.18,0,2.35,0,3.53,0,1.93-.03,3.65-1.56,3.85-3.42.09-.81.08-1.64.08-2.44,0-.32,0-.65,0-.97,0-.59-.3-.96-.83-.97Z" />
                  <path class="cls-1"
                    d="M8.35,12.43c.17.17.4.32.66.32.21,0,.44-.09.68-.34l3.29-3.29c.32-.32.65-.65.96-.98.27-.29.31-.66.11-1.01-.19-.33-.54-.48-.9-.38-.17.04-.33.15-.51.33-.84.83-1.67,1.67-2.54,2.54l-.24.24V1.14s0-.07,0-.07c0-.12,0-.23-.01-.35-.05-.43-.37-.71-.81-.72-.25,0-.46.07-.6.21-.17.17-.25.42-.25.76v8.89s-1.01-1.01-1.01-1.01c-.6-.6-1.21-1.21-1.81-1.81-.19-.18-.4-.29-.62-.31-.23-.02-.45.07-.62.24-.35.35-.32.87.05,1.25,1.4,1.4,2.8,2.81,4.2,4.21Z" />
                </g>
              </svg>
            </div>


          </div>
        </div>
      </div>

      <div class="more-attachments" v-if="attachments.length > 3" @click="openAttachmentDialog()">
        {{ attachments.length - firstArray().length }}+
      </div>
    </div>
    <email-expanded-file-reader :file_list="attachments" ref="attachmentViewer" />

  </div>
</template>

<script>
import { getShortFileName, returnFileTypeImage } from '../../../../helpers/file';
import EmailExpandedFileReader from '../../file-management/EmailExpandedFileReader.vue';
export default {
  components: { EmailExpandedFileReader },
  props: {
    attachments: {
      type: Array,
      default: [],
    }
  },
  methods: {
    /**
     * Method that opens email create/edit modal window.
     */
    openAttachmentDialog() {
      // Opens the dialog for a new email draft
      this.$refs.attachmentViewer.openDialog(this.attachments);

    },
    getFileIcon(filename) {
      return returnFileTypeImage(filename)
    },
    getFileNameShorter(filename) {
      return getShortFileName(filename)
    },
    cumulateAttachmentSize() {
      let cumulated_size = (
        this.attachments.map((p) => p.size).reduce((a, b) => a + b, 0) *
        0.000001
      ).toFixed(2);
      return cumulated_size;
    },
    downloadAttachment(attachment) {
      // Decode Base64 content using more efficient method
      const byteCharacters = atob(attachment.contentBytes);
      const byteNumbers = Uint8Array.from(byteCharacters, char => char.charCodeAt(0));

      // Create Blob
      const blob = new Blob([byteNumbers], { type: attachment.contentType });

      // Create a download link
      const link = document.createElement("a");
      const blobUrl = URL.createObjectURL(blob);
      link.href = blobUrl;
      link.download = attachment.name || this.$t('components.email.attachments.downloaded_file');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up blob URL to prevent memory leaks
      URL.revokeObjectURL(blobUrl);
    },
    firstArray() {
      console.log("All attachments", this.attachments);
      if (this.attachments.length > 3) {
        return this.attachments.slice(0, 2);
      } else {
        return this.attachments;
      }
    },
  },
};
</script>

<style></style>
